<template>
  <div class="ranking-container">

    <div class="kc-crumbs">
      <router-link :to="address">{{courseName}}</router-link>
      <img src="../../assets/img/icon-more.png">
      <a href="javascript:;" class="kc-crumbs-state">排行榜</a>
    </div>

  	<div class="ranking-top">
  		<div class="ranking-top-number">
  			<strong>{{rankdetail.totalPeople}}</strong>
  			总计人数
  		</div>
  		<div class="ranking-top-number">
  			<strong>{{rankdetail.rank}}</strong>
  			我的排名
  		</div>
  		<div class="ranking-top-number">
  			<strong>{{rankdetail.finishPeople}}</strong>
  			完成人数
  		</div>
  		<div class="ranking-top-number">
  			<strong>{{rankdetail.ongoingPeople}}</strong>
  			进行人数
  		</div>
  		<div class="ranking-top-number">
  			<strong>{{rankdetail.notStartPeople}}</strong>
  			未开始
  		</div>
  	</div>
  	<div class="ranking-number">
  		<ul>
  			<li v-for="(item,index) in ranklist" :key="index">
  				<span class="ranking-one-number" :class="classObject(item)">{{item.rank}}</span>
  				<img :src="item.userImage ? item.userImage : userImage" class="ranking-one-head" >
  				<div class="ranking-name">
  					<div class="ranking-name-name">{{item.realName}}</div>
  					<div class="ranking-name-company">{{item.position}}</div>
  				</div>
  				<span class="ranking-one-ranking">{{item.rate}}%</span>
  			</li>
  		</ul>
  	</div>
    <div style="text-align: center;margin-top: 20px;" >
      <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </div>
  </div>
</template>

<script>
  import {ApiGettaskSum,ApiGettaskRank} from '../../net/course/index.js'
  import {getCookie,setCookie} from '../../untils/common.js'
  export default{
    data:function(){
      return{
        rankdetail:{},
        ranklist : [],
        planid : null,
        pageNum:1,
        total:10,
        pageSize:10,
        currentPage3 : 1,
        courseName : '',
        userImage : 'http://statics.sgn.7east.cn/photo/20201207172318.png'
      }
    },
    methods: {
      handleCurrentChange(index){
        this.pageNum = index;
        this.getrank();
      },
      getnum(){
        const param = {
          taskId : this.planid
        }
        ApiGettaskSum(param).then(res=>{
          if(res.code == 200){
            this.rankdetail = res.value;
          }
        })
      },
      getrank(){
        const param = {
          pageNum : this.pageNum,
          pageSize : this.pageSize,
          taskId : this.planid,
          platform : 'pc'
        }
        ApiGettaskRank(param).then(res=>{
          if(res.code == 200){
            this.total = res.pc.total;
            this.ranklist = res.pc.details
          }
        })
      },
      classObject(item){
        return {
          rank1: item.rank==1,
          rank2:item.rank==2,
          rank3:item.rank==3,
          rank_member : item.rank==3||item.rank==2||item.rank==1
        }
      },
    },
    mounted() {
      this.planid = this.$route.query.id;
      this.getnum();
      this.getrank();

      this.courseName = this.$route.query.courseName;
      this.address = '/PlanDetail?id=' + getCookie('plid')
    }
  }
</script>

<style>
  .ranking-container{
  	width: 760px;
  	margin: 0 auto;
  	margin-top: 20px;
  }
  .ranking-top{
  	width: 640px;
  	padding:30px 60px;
  	background:#fff;
  	border-radius: 6px;
  	overflow: hidden;
  	}
  .ranking-top-number{
  	float: left;
  	font-size: 16px;
  	width: 128px;
  	text-align: center;
  	color: #999;
  	text-decoration: none;
  }
  .ranking-top-number strong{
  	font-size: 24px;
  	display: block;
  	color: #000;
  	margin-bottom: 4px;
  }
  .ranking-number{
  	width: 760px;
  	margin-top: 20px;
  	background:#fff;
  	border-radius: 6px;
  	overflow: hidden;
  	padding-top: 20px;
  	padding-bottom: 20px;
  }
  .ranking-number ul{
  	margin:0;
  	padding:0;
  	overflow: hidden;
  }
  .ranking-number ul li{
  	list-style-type: none;
  	margin-left: 50px;
  	margin-right: 50px;
  	padding-top: 15px;
  	padding-bottom: 15px;
  	border-bottom: 1px solid #e5e5e5;
  	float: left;
  	width: 660px;
  }
  .ranking-one-number{
  	width: 30px;
  	height: 30px;
  	line-height: 30px;
  	text-align: center;
  	float: left;
  	margin-top: 3px;
  	color: #7f7f7f;
  }
  .ranking-one-number-img{
  	width: 30px;
  	margin-right: 10px;
  	margin-left: 10px;
  }
  .ranking-one-head{
  	width:36px;
  	height: 36px;
  	border-radius: 50%;
  	float:left;
  	margin-left: 10px;
  }
  .ranking-name{
  	float: left;
  	margin-left: 10px;
  	width: 450px;
  }
  .ranking-name-name{
  	float: left;
  	font-size: 14px;
  	color: #252525;
  	width: 450px;
  	line-height: 18px;
  	overflow: hidden;
  	text-overflow: ellipsis;
  	white-space: nowrap;
  }
  .ranking-name-company{
  	float: left;
  	font-size: 14px;
  	line-height: 18px;
  	color: #7f7f7f;
  	width:450px;
  	overflow: hidden;
  	text-overflow: ellipsis;
  	white-space: nowrap;
  }
  .ranking-one-ranking{
  	height: 36px;
  	line-height: 36px;
  	float: right;
  }
  .rank1{
    background-image: url(../../assets/img/ranking-one1.png);
  }
  .rank2{
    background-image: url(../../assets/img/ranking-two1.png);
  }
  .rank3{
    background-image: url(../../assets/img/ranking-three1.png);
  }
  .rank_member{
    background-size: cover;
    background-position: 0 2px;
    background-repeat: no-repeat;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/RankList/RankList.vue